import { roleIsAllowed } from "@shared/components/RoleAuthorized/roleIsAllowed";
import { useAuth } from "@shared/hooks/useAuth";
import { blurActiveElement } from "@shared/utils/blur-active-element";
import { UserRoles } from "@store/auth.store";
import { useUIStore } from "@store/ui.store";

export const useDevTools = () => {
  const isDevToolsOpen = useUIStore((state) => state.isDevToolsOpen);
  const toggleDevTools = useUIStore((state) => state.toggleDevTools);
  const { isAuthenticated, user } = useAuth();

  const isDevToolsEnabled =
    isAuthenticated && roleIsAllowed(user?.roles ?? [], [UserRoles.Admin]);

  const handleToggleDevTools = (open: boolean) => {
    toggleDevTools(open);
    blurActiveElement();
  };

  return {
    isDevToolsEnabled,
    handleToggleDevTools,
    isDevToolsOpen,
  };
};
